import React, { forwardRef, useState } from 'react';
import {
  DndContext,
  useSensors,
  useSensor,
  PointerSensor,
} from '@dnd-kit/core';
import { DraggableDialog } from './DraggableDialog';
import { useConditions } from './useConditions';
import { INIT_POS } from './constants';

export const DraggableDialogPosition = forwardRef(
  ({ width, children }, ref) => {
    const [position, setPosition] = useState(INIT_POS);

    const conditions = useConditions(ref);

    const handleDragEnd = (event) => {
      const { delta } = event;
      setPosition((prev) => {
        const newX = prev.x + delta.x;
        const newY = prev.y + delta.y;

        return {
          x: Math.max(conditions.minX, Math.min(newX, conditions.maxX)),
          y: Math.min(conditions.maxY, Math.max(newY, conditions.minY)),
        };
      });
    };

    const sensors = useSensors(
      useSensor(PointerSensor, {
        activationConstraint: {
          distance: 8,
        },
      })
    );

    return (
      <DndContext onDragEnd={handleDragEnd} sensors={sensors}>
        <DraggableDialog
          position={position}
          width={width}
          conditions={conditions}
          ref={ref}
        >
          {children}
        </DraggableDialog>
      </DndContext>
    );
  }
);
